module.exports = __webpack_public_path__ + "assets/images/andrew_perrot3e4556aa.jpg";